import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import { OverlayTrigger } from "react-bootstrap";
import _ from "lodash";
import { AppSettings } from "../../constants";
import TableList from "../../components/TableList";
import { CheckBoxSingle } from "../../components/checkboxes/check-box-single";
import { checkIsOverdueWorkOrder } from "helper/unit-helper";
import * as RFSActionType from "../constants";
import { Modal } from "react-bootstrap";

const defaultParams = {
  defaultSortName: "refNo",
  defaultSortOrder: "descending",
  sizePerPage: 100,
};

let defaultFilter =
  AppSettings.clientTypeValue !== "Homeowner"
    ? [0, 1, 2, 6] // Open, Pending, Request
    : AppSettings.WO_STATUS_VALUE.map((item) => item.key);
class WOPreview extends Component {
  static propTypes = {
    WorkOrders: PropTypes.object,
    data: PropTypes.array,
  };
  constructor(props) {
    super(props);

    this.state = {
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      data: [],
      sizePerPage: defaultParams.sizePerPage,
      column: [
        {
          field: "refNo",
          header: "WO#",
          hidden: false,
          isKey: true,
          sort: true,
          dataAlign: "left",
          headerAlign: "left",
          widthStyle: "name",
        },
        {
          field: "WOInformation.Trade",
          header: "Trade",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderTrade.bind(this),
          widthStyle: "name",
        },
        {
          field: "WOInformation.SubcontractorOfProject",
          header: "Assigned to",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderAssigned.bind(this),
          widthStyle: "name",
        },
        {
          field: "title",
          header: "Summary",
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderTitle.bind(this),
          widthStyle: "address",
          apiField: "Summary",
        },
        {
          field: "description",
          header: "Description",
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderDescription.bind(this),
          widthStyle: "address",
          apiField: "Description",
        },
        {
          field: "name",
          header: "WOT",
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderWOT.bind(this),
          widthStyle: "name",
          apiField: "name",
        },
        {
          field: "WOInformation.itemToRepair",
          header: "Item to repair",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderItemtorepair.bind(this),
          widthStyle: "name",
        },
        {
          field: "WOInformation.problem",
          header: "Problem",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderProblem.bind(this),
          widthStyle: "name",
        },
      ],
      refNoCheckList: {},
      isSetDefaultCheckList: false,
      isShowPopup: false,
      checkedValues: defaultFilter,
      WOdata: this.props.data,
      isOpen: false,
      refNo: "",
    };
  }

  componentDidMount() {
    this.onApplyAction(this.props);
    // console.log('this.props.data ', this.props.data)
  }

  componentWillReceiveProps(nextProps) {
    const { WorkOrders } = nextProps;

    if (!isEmpty(WorkOrders.WorkOrders)) {
      this.setState({
        workOrders: WorkOrders.WorkOrders,
      });
    }

    if (this.state.modeClose && !this.state.isSetDefaultCheckList) {
      this.handleCheckBoxList(nextProps);
    }

    if (
      nextProps.ManagerStore.RFSProfile &&
      nextProps.ManagerStore.RFSProfile.workOrders &&
      nextProps.ManagerStore.RFSProfile.workOrders.items
    ) {
      let items = [...nextProps.ManagerStore.RFSProfile.workOrders.items];

      const { checkedValues, defaultSortName, defaultSortOrder } = this.state;

      items = items.filter((item) => checkedValues.includes(item.status));

      items = this.handleSorting(items, defaultSortName, defaultSortOrder);

      this.setState({ data: items });
    }
  }

  customRenderTrade(item) {
    if (item) {
      return (
        <span style={{ fontWeight:'bold', color:'#4267b2' }}>
          {item.trade ? item.trade.name : "-"}
        </span>
      );
    }
    return null;
  }

  customRenderItemtorepair(item) {
    if (item) {
      return (
        <span style={{ fontWeight:'bold', color:'#4267b2' }}>
          {item.itemToRepair ? item.itemToRepair.name : "-"}
        </span>
      );
    }
    return null;
  }

  customRenderProblem(item) {
    if (item) {
      return (
        <span style={{fontWeight:'bold', color:'#4267b2' }}>
          {item.problem ? item.problem.name : "-"}
        </span>
      );
    }
    return null;
  }

  customRenderTitle(item) {
    return <div style={{ whiteSpace: "break-spaces" }}>{item.title}</div>;
  }

  customRenderWOT(item) {
    return (
      <div style={{ whiteSpace: "break-spaces", fontWeight:'bold', color:'#4267b2' }}>
        {item.workOrderType && item.workOrderType.name}
      </div>
    );
  }

  customRenderDescription(item) {
    return <div style={{ whiteSpace: "break-spaces" }}>{item.description}</div>;
  }

  customRenderAssigned(item) {
    console.log('assignedUser',item.assignedUser)
    if (item) {
      if (item.subcontractorProfile.name !== '') {
        return (
          <span style={{ fontWeight:'bold', color:'#4267b2' }}>
            {item.subcontractorProfile.name}
          </span>
        );
      }
      if (item.assignedUser.name !== '') {
        return (
          <span style={{ fontWeight:'bold', color:'#4267b2' }}>
            {item.assignedUser.name}
          </span>
        );
      }
      return "-";
    }
    return "-";
  }

  onChecked = (refNo) => {
    this.setState({
      isOpen: true,
      refNo,
    });
  };

  onApplyAction = (props) => {
    const checkboxColumn = {
      field: "",
      header: "",
      hidden: false,
      isKey: false,
      sort: false,
      dataAlign: "left",
      headerAlign: "left",
      columnClassName: "td-width-50-px",
      customRender: this.customRenderCheckboxColumn.bind(this),
    };
    const newColumnState = [...this.state.column];
    newColumnState.unshift(checkboxColumn);
    this.setState({
      column: newColumnState,
    });
    // this.handleCheckBoxList(props);
  };

  customRenderCheckboxColumn(item) {
    const { status, refNo } = item;
    // const disabled =
    //   (AppSettings.clientTypeValue === "Homeowner" && status !== 4) ||
    //   (AppSettings.clientTypeValue !== "Homeowner" &&
    //     status !== 1 &&
    //     status !== 4);
    // if (disabled) {
    //   return (
    //     <div>
    //       <CheckBoxSingle
    //         checked={
    //           this.state.refNoCheckList[refNo] !== null &&
    //           this.state.refNoCheckList[refNo] === true
    //         }
    //         ref={(c) => {
    //           this.check = c;
    //         }}
    //         name="checkToSignoff"
    //         disabled={disabled}
    //         className="checkbox-default"
    //         onChecked={() => this.onChecked(refNo)}
    //         style={{ marginTop: -7 }}
    //       />
    //     </div>
    //   );
    // } else {
    return (
      <CheckBoxSingle
        checked={true}
        ref={(c) => {
          this.check = c;
        }}
        name="checkToSignoff"
        // disabled={disabled}
        className="checkbox-default"
        onChecked={() => this.onChecked(refNo)}
        style={{ marginTop: -7 }}
      />
    );
    // }
  }

  refreshList(params) {
    const { defaultSortName, defaultSortOrder, sizePerPage } = params;

    this.setState(
      {
        defaultSortName,
        defaultSortOrder,
        sizePerPage,
      },
      () => {
        let currentData = [...this.state.data];

        currentData = this.handleSorting(
          currentData,
          defaultSortName,
          defaultSortOrder
        );

        this.setState({ data: currentData });
      }
    );
  }

  handleSorting = (items, sortName, sortOder) => {
    const order = sortOder === "ascending" ? "asc" : "desc";

    const results = _.orderBy(items, sortName, order);

    return results;
  };

  render() {
    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
    };
    const { isOpen, refNo } = this.state;
    return (
      <div>
        <p
          className="text-danger"
          style={{ marginTop: "15px", marginLeft: "20px", fontSize: "15px" }}
        >
          Disclaimer: Please NOTE unselecting a WO here will remove them from
          being updated, but incase you change you mind you can always go back
          to step 1 and repeat the process.{" "}
        </p>
        <TableList
          column={this.state.column}
          defaultParams={defaultParams}
          pagination={true}
          data={this.state.WOdata}
          options={options}
          refreshPageList={this.refreshList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          trClassName={(row) => checkIsOverdueWorkOrder(row)}
          containerStyle={{ maxHeight: 300 }}
          reassignCSS={true}
          // showButtonMenu={true}
          //onContextMenu={this.onContextMenu.bind(this)}
        />
        <Modal
          dialogClassName="confirm-cancel-save-eoc-template-dialog"
          show={isOpen}
          centered="true"
          size="sm"
        >
          <Modal.Header>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.WOdata.length === 1 ? (
              <p>
                Cannot unselect the last WO. Kindly press the Back button to
                update WO with diffent values!
              </p>
            ) : (
              <p>
                Unselecting a WO here would not update the WO. Are you sure you
                want to continue?
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="suspend-group-btn" style={{ float: "left" }}>
              {this.state.WOdata.length === 1 ? (
                <button
                  style={{ marginLeft: 10 }}
                  className="btn btn-primary btn-siteone"
                  onClick={() => {
                    this.setState({ isOpen: false });
                  }}
                >
                  Ok
                </button>
              ) : (
                <div>
                  <button
                    className="btn btn-primary btn-siteone-default"
                    onClick={() => {
                      this.setState({ isOpen: false });
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    style={{ marginLeft: 10 }}
                    className="btn btn-primary btn-siteone"
                    onClick={() => {
                      const data = this.state.WOdata.filter(
                        (e) => e.refNo !== refNo
                      );
                      this.setState({ WOdata: data, isOpen: false });
                      this.props.dispatch({
                        type: RFSActionType.PREVIEW_WO_LIST,
                        payload: data,
                      });
                    }}
                  >
                    Confirm
                  </button>
                </div>
              )}
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ManagerStore: state.RFSStore,
    WorkOrders: state.WorkOrderReducer,
    LotStore: state.LotStore,
  };
};

export default connect(mapStateToProps)(WOPreview);



// WEBPACK FOOTER //
// ./src/Request-Services/Components/WOPreview.js